import { render, staticRenderFns } from "./SectionContainer.vue?vue&type=template&id=35ba13d2&scoped=true"
import script from "./SectionContainer.vue?vue&type=script&lang=js"
export * from "./SectionContainer.vue?vue&type=script&lang=js"
import style0 from "./SectionContainer.vue?vue&type=style&index=0&id=35ba13d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba13d2",
  null
  
)

export default component.exports